var chunkMapping = {
	"507": [
		2883
	],
	"1353": [
		81353
	],
	"1593": [
		2689
	],
	"2035": [
		15480,
		4835,
		71827
	],
	"3124": [
		33124
	],
	"4073": [
		72065
	],
	"5103": [
		75103
	],
	"5271": [
		42407
	],
	"5440": [
		41512
	],
	"5672": [
		45672
	],
	"7413": [
		47413
	]
};
var idToExternalAndNameMapping = {
	"2689": [
		"default",
		"./NotificationBar",
		33537
	],
	"2883": [
		"default",
		"./SageSearchKycGate",
		33537
	],
	"4835": [
		"default",
		"./ReviewTransaction",
		65897
	],
	"15480": [
		"default",
		"./AddToRiskshieldBlackList",
		65897
	],
	"33124": [
		"default",
		"./WebsiteDetails",
		65425
	],
	"41512": [
		"default",
		"./MerchantCareTicketDashboard",
		33537
	],
	"42407": [
		"default",
		"./RiskMetrics",
		65897
	],
	"45672": [
		"default",
		"./DynamicForm",
		12384
	],
	"47413": [
		"default",
		"./NotificationProvider",
		33537
	],
	"71827": [
		"default",
		"./RiskShield",
		65897
	],
	"72065": [
		"default",
		"./NotificationPopover",
		33537
	],
	"75103": [
		"default",
		"./SuccessRateAlerts",
		33537
	],
	"81353": [
		"default",
		"./GenericSelfServe",
		33537
	]
};
__webpack_require__.f.remotes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			var getScope = __webpack_require__.R;
			if(!getScope) getScope = [];
			var data = idToExternalAndNameMapping[id];
			if(getScope.indexOf(data) >= 0) return;
			getScope.push(data);
			if(data.p) return promises.push(data.p);
			var onError = (error) => {
				if(!error) error = new Error("Container missing");
				if(typeof error.message === "string")
					error.message += '\nwhile loading "' + data[1] + '" from ' + data[2];
				__webpack_require__.m[id] = () => {
					throw error;
				}
				data.p = 0;
			};
			var handleFunction = (fn, arg1, arg2, d, next, first) => {
				try {
					var promise = fn(arg1, arg2);
					if(promise && promise.then) {
						var p = promise.then((result) => (next(result, d)), onError);
						if(first) promises.push(data.p = p); else return p;
					} else {
						return next(promise, d, first);
					}
				} catch(error) {
					onError(error);
				}
			}
			var onExternal = (external, _, first) => (external ? handleFunction(__webpack_require__.I, data[0], 0, external, onInitialized, first) : onError());
			var onInitialized = (_, external, first) => (handleFunction(external.get, data[1], getScope, 0, onFactory, first));
			var onFactory = (factory) => {
				data.p = 1;
				__webpack_require__.m[id] = (module) => {
					module.exports = factory();
				}
			};
			handleFunction(__webpack_require__, data[2], 0, 0, onExternal, 1);
		});
	}
}